import React, { Component } from "react";
import { connect } from "react-redux";
import Tabs from "../../../common/tabs/Tabs.js";
import FileCard from "./FileCard.js";
import socket from "../../../helpers/socket.js";
import { messagesFileRequest } from "../../../actions/chat/messageActions.js";

import "./Files.css";

class Files extends Component {
	constructor(props) {
		super(props);

		this.state = {
			selectedTab: "SENT",
			currentFileName: null,
			currentFileCaption: null,
			downloading: false
		};
	}

	/**
	 * Click handler for tab buttons
	 */
	onTabClick = tabName => {
		this.setState({ selectedTab: tabName });
	};

	/**
	 * Click handler for download button
	 */
	onDownloadClick = (file, e) => {
		e.preventDefault();
		this.setState({
			currentFileName: file.fileName,
			currentFileCaption: file.fileCaption,
			downloading: true
		});
		this.props.messagesFileRequest({ fileName: file.fileName });
	};

	componentDidMount() {
		// Emitting this event sends back all the files for user
		socket.emit("allFilesForUser");
	}

	componentWillReceiveProps(nextProps) {
		if (!this.state.downloading) return;

		let tmp = nextProps.files.filter(a => {
			return a.fileName === this.state.currentFileName && a.p === "100.0%";
		});
		if (tmp.length > 0) {
			var blob = new Blob([Buffer.concat(tmp[0].buff)]);
			const fileObjectURL = window.URL.createObjectURL(blob);
			var link = document.createElement("a");
			link.href = fileObjectURL;
			link.download = this.state.currentFileCaption;
			link.style.display = "none";
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
			this.setState({ downloading: false });
		}
	}

	render() {
		const { selectedTab } = this.state;
		const { allFiles } = this.props;
		const files =
			selectedTab === "SENT"
				? allFiles.filter(f => f.owner === this.props.user.id)
				: allFiles.filter(f => f.to === this.props.user.id);

		return (
			<div className="files-container">
				<div className="tabs-container">
					<Tabs
						onTabClick={this.onTabClick}
						selectedTab={this.state.selectedTab}
						tabs={["SENT", "RECEIVED"]}
					/>
				</div>

				{files.length === 0 && (
					<div className="message">
						You haven't {selectedTab.toLowerCase()} any files yet!
					</div>
				)}

				{files.map((f, i) => (
					<FileCard key={i} file={f} onDownload={this.onDownloadClick} />
				))}
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		user: state.auth.currentUser,
		files: state.attachmentReducer.files,
		allFiles: state.attachmentReducer.allFiles
	};
};

const mapDispatchToProps = {
	messagesFileRequest
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Files);



// WEBPACK FOOTER //
// ./src/components/main/files/Files.js